export const initialAddEmplHistResetState = {
  step_number: 0,
  is_add_disabled: true,
  is_next_disabled: true,
  show_add_button: true,
  show_next_button: false,
  currentTab: "Employment Experience",
  show_training_info: false,
  title: "",
  title_error: false,
  company_name: "",
  company_name_error: false,
  employment_start_date: "",
  employment_start_date_error: false,
  employment_start_date_error_text: "",
  employment_end_date: "",
  employment_end_date_error: false,
  employment_end_date_display: "",
  street_address: "",
  street_address_error: false,
  address2: "",
  reason_for_leaving: "",
  city: "",
  city_error: false,
  state: "",
  state_error: false,
  zip_code: "",
  zip_code_error: false,
  country: "",
  country_error: false,
  contact_phone: "",
  contact_phone_error: false,
  training_start_date: "",
  training_start_date_error: false,
  training_start_date_error_text: "",
  training_end_date: "",
  training_end_date_error: false,
  training_end_date_error_text: "",
  subsidy: "",
  subsidy_error: false,
  sales: "",
  irb: "",
  currently_working: "",
  contact_employer: "",
  individual_life: "",
  individual_annuity: "",
  individual_disability: "",
  individual_longterm: "",
  full_time_role: "",
  training: "",
  formHasError: false,
  ctrl_with_focus: "",
  is_form_saved: false,
  fulltime_student: "",
  homemaker: "",
  unemployment: "",
  military: "",
  travel: "",
  other: "",
  other_text: "",
  other_text_error: false,
  break_start_date: "",
  break_start_date_error: false,
  break_start_date_error_text: "",
  break_end_date: "",
  break_end_date_error: false,
  break_end_date_error_text: "",
  show_other_panel: false,
  display_company_name: "",
  display_title: "",
  display_start_date: "",
  display_end_date: "",
  is_there_gap: false,
  review_edit: false,
  end_date_disabled: false,
  may_we_contact_employer: false,
  show_state_required: false,
  showModal: false,
  usps_address: "",
  usps_address2: "",
  usps_city: "",
  usps_state: "",
  usps_zip_code: "",
  usps_country: "",
  urbanization: "",
  addressNotFound: false,
  is_validated: true,
  showUrbanization: false,
  form_has_changed: false,
  showBackModal: false,
  industry_select_desc: "",
  industry_select_id: "",
  showSaveLoader: false,
  showEmploymentBreakTab: true,
  showEmploymentExperienceTab: true,
  disableEmploymentBreak: false,
  psrCheckbox: false,
  psrPreviewData: [],
  currently_onbreak:"",
  break_end_date_disabled: false,
};

export const initialAddEmplHistState = {
  step_number: 0,
  is_add_disabled: true,
  is_next_disabled: true,
  show_add_button: true,
  show_next_button: false,
  currentTab: "Employment Experience",
  show_training_info: false,
  title: "",
  title_error: false,
  company_name: "",
  company_name_error: false,
  employment_start_date: "",
  employment_start_date_error: false,
  employment_start_date_error_text: "",
  employment_end_date: "",
  employment_end_date_error: false,
  employment_end_date_display: "",
  street_address: "",
  street_address_error: false,
  address2: "",
  reason_for_leaving: "",
  city: "",
  city_error: false,
  state: "",
  state_error: false,
  zip_code: "",
  zip_code_error: false,
  country: "",
  country_error: false,
  contact_phone: "",
  contact_phone_error: false,
  training_start_date: "",
  training_start_date_error: false,
  training_start_date_error_text: "",
  training_end_date: "",
  training_end_date_error: false,
  training_end_date_error_text: "",
  subsidy: "",
  subsidy_error: false,
  sales: "",
  irb: "",
  currently_working: "",
  contact_employer: "",
  individual_life: "",
  individual_annuity: "",
  individual_disability: "",
  individual_longterm: "",
  full_time_role: "",
  training: "",
  formHasError: false,
  ctrl_with_focus: "",
  is_form_saved: false,
  fulltime_student: "",
  homemaker: "",
  unemployment: "",
  military: "",
  travel: "",
  other: "",
  other_text: "",
  other_text_error: false,
  break_start_date: "",
  break_start_date_error: false,
  break_start_date_error_text: "",
  break_end_date: "",
  break_end_date_error: false,
  break_end_date_error_text: "",
  show_other_panel: false,
  display_company_name: "",
  display_title: "",
  display_start_date: "",
  display_end_date: "",
  is_there_gap: false,
  review_edit: false,
  end_date_disabled: false,
  may_we_contact_employer: false,
  show_state_required: false,
  showModal: false,
  usps_address: "",
  usps_address2: "",
  usps_city: "",
  usps_state: "",
  usps_zip_code: "",
  usps_country: "",
  urbanization: "",
  addressNotFound: false,
  is_validated: true,
  showUrbanization: false,
  form_has_changed: false,
  showBackModal: false,
  industry_select_desc: "",
  industry_select_id: "",
  industry_select_options: [],
  showSaveLoader: false,
  showEmploymentBreakTab: true,
  showEmploymentExperienceTab: true,
  disableEmploymentBreak: false,
  psrCheckbox: false,
  psrPreviewData: [],
  currently_onbreak:"",
  break_end_date_disabled: false,
};
